import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Box,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { RootState } from 'interfaces';
import { head } from 'lodash';
import { deleteToken } from 'firebase/messaging';
import { messaging } from 'firebaseInit';
import { getPath as getPageEmployeePath } from 'pages/PageEmployee';
import { useSession } from 'providers/SessionProvider';

const useStyles = makeStyles(() => ({
  label: {
    alignItems: 'center',
    gridGap: 8,
    padding: 2,
  },
}));

const UserAvatarButton = () => {
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down('md'));
  const user = useSelector((state: RootState) => state.user);
  const classes = useStyles();
  const { keycloak } = useSession();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleLogOut = (): void => {
    setAnchorEl(null);

    deleteToken(messaging).then(() => {
      keycloak?.logout();
    });
  };

  return (
    <>
      <IconButton
        size="small"
        TouchRippleProps={{ center: downMd }}
        style={{ color: 'inherit', gridGap: 8, ...(downMd ? {} : { borderRadius: '10em' }) }}
        classes={{ label: classes.label }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label="Профиль"
      >
        {!downMd && (
          <Box sx={{ textAlign: 'right', ml: 1 }}>
            <Typography variant="caption">{user.username}</Typography>

            <Typography variant="body2" noWrap>
              <b>
                {user.lastName} {user.firstName}
              </b>
            </Typography>
          </Box>
        )}

        <Avatar src={`data:image/png;base64, ${user.thumbnailPhoto}`}>
          {head(user.lastName)}
          {head(user.firstName)}
        </Avatar>
      </IconButton>

      <Menu
        id="user-menu"
        keepMounted
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem component={RouterLink} to={getPageEmployeePath(user!.username)} onClick={() => setAnchorEl(null)}>
          Профиль
        </MenuItem>

        <MenuItem onClick={handleLogOut}>Выйти</MenuItem>
      </Menu>
    </>
  );
};

export default UserAvatarButton;
